export function ytId(url) {
  if (!url || typeof url !== "string") return null;
  const s = url.trim();
  // Already a bare 11-char video id
  if (/^[A-Za-z0-9_-]{11}$/.test(s)) return s;
  const patterns = [
    /[?&]v=([A-Za-z0-9_-]{11})/,
    /(?:youtu\.be\/|youtube\.com\/(?:embed|shorts|live|v)\/)([A-Za-z0-9_-]{11})/,
    /([A-Za-z0-9_-]{11})/, // last resort: first 11-char token
  ];
  for (const p of patterns) {
    const m = s.match(p);
    if (m) return m[1];
  }
  return null;
}

export function ytThumb(url) {
  const id = ytId(url);
  return id ? `https://img.youtube.com/vi/${id}/maxresdefault.jpg` : null;
}

export function ytEmbed(url, autoplay = false) {
  const id = ytId(url);
  if (!id) return null;
  return `https://www.youtube.com/embed/${id}?rel=0&modestbranding=1${autoplay ? "&autoplay=1" : ""}`;
}
